import TabBar from '@splunk/react-ui/TabBar';
import { variables } from '@splunk/themes';
import styled from 'styled-components';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../../common/theme/ThemeProvider';

export default function ModernDashboardsTabs(): JSX.Element {
    const themeKey = useLegacyThemeServiceKey();

    return (
        <ThemeProvider colorScheme={themeKey}>
            <StyledTabBar activeTabId={CLASSIC_DAHSBOARDS_ID}>
                <TabBar.Tab
                    label="Classic dashboards"
                    tabId={CLASSIC_DAHSBOARDS_ID}
                    to="#/dashboards"
                />
                <TabBar.Tab label="New dashboards" tabId="newDashboards" to="#/dash" />
            </StyledTabBar>
        </ThemeProvider>
    );
}

const CLASSIC_DAHSBOARDS_ID = 'classicDashboards';

const StyledTabBar = styled(TabBar)`
    margin-inline: ${variables.spacingLarge};

    &&& a {
        color: inherit;
    }
`;
